function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/web.dom-collections.iterator.js";
import React, { useState, useRef } from 'react';
import ArrowDropDown from '@pixel/assets/icons/ArrowDropDown';
import { ButtonGroup, Button, Popper, Grow, Paper, ClickAwayListener, MenuList } from '@mui/material';
const BUTTON_SX_NO_BORDER_RADIUS_RIGHT = {
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0,
  borderRight: 'none !important'
};
const BUTTON_SX_NO_BORDER_RADIUS_LEFT = {
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0
};
export const SplitButton = _ref => {
  let {
    id,
    color = 'secondary',
    variant = 'outlined',
    text,
    DropdownMenu,
    ariaLabel,
    icon,
    onClick,
    href,
    hidden = false,
    ariaLabelDropdown = 'dropdown',
    disabled
  } = _ref;
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };
  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ButtonGroup, {
    ref: anchorRef,
    id: id,
    color: color,
    variant: variant,
    "aria-label": ariaLabel || text,
    disabled: disabled,
    sx: {
      visibility: hidden ? 'hidden' : undefined,
      whiteSpace: 'nowrap',
      marginLeft: '5px',
      marginRight: '5px'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClick,
    startIcon: icon,
    href: href,
    sx: BUTTON_SX_NO_BORDER_RADIUS_RIGHT
  }, text), /*#__PURE__*/React.createElement(Button, {
    size: "small",
    "aria-haspopup": "menu",
    "aria-label": "".concat(ariaLabel || text, " ").concat(ariaLabelDropdown),
    onClick: handleToggle,
    variant: variant,
    color: color,
    sx: BUTTON_SX_NO_BORDER_RADIUS_LEFT
  }, /*#__PURE__*/React.createElement(ArrowDropDown, null))), /*#__PURE__*/React.createElement(Popper, {
    open: open,
    anchorEl: anchorRef.current,
    role: undefined,
    transition: true
  }, _ref2 => {
    let {
      TransitionProps,
      placement
    } = _ref2;
    return /*#__PURE__*/React.createElement(Grow, _extends({}, TransitionProps, {
      style: {
        transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
      }
    }), /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(ClickAwayListener, {
      onClickAway: handleClose
    }, /*#__PURE__*/React.createElement(MenuList, {
      autoFocusItem: true
    }, typeof DropdownMenu === 'function' && DropdownMenu({
      onCloseMenu: handleClose
    })))));
  }));
};
export default SplitButton;